import axios from 'axios';
import { ApiUrl } from '../services/ApiRest';
import React, { Component } from 'react'
import {
    NavLink as Link,
    withRouter
} from 'react-router-dom';

import Cookies from 'universal-cookie';
const cookie = new Cookies();
const urlAdministrativo = ApiUrl + "admins/"; //pasar id del estudiante
const idAdministrativo = cookie.get("idAdministrativo");    //declaramos una variable para usar la cookie del login

class Sidebar extends Component {

    componentDidMount() {
        // Get que devuelve los datos de un estudiante recibiendo un id
        axios.get(urlAdministrativo + idAdministrativo + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(res => {
                const estudiante = res.data;
                this.setState({ estudiante });
                cookie.set('nombres', estudiante.nombres_administrativo, { path: "/" })
                cookie.set('apellidos', estudiante.apellidos_administrativo, { path: "/" })
            })
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }
    render() {
        return (

            <div id="layoutSidenav_nav" style={{ width: 226 }}>
                <nav
                    className="sb-sidenav sb-sidenav-dark-custom accordion animate__animated animate__fadeInLeft"
                    id="sidenavAccordion"
                >
                    <div className="sb-sidenav-menu px-2 pt-3">
                        {/* Encabezado */}
                        <div className="sb-sidenav-menu-heading text-uppercase text-muted small mb-2">
                            <p className="text-white mb-0">Personal Administrativo</p>
                        </div>

                        {/* Link principal */}
                        <Link to="/login" className="nav-link-custom">
                            <i className="fas fa-home me-2" />
                            Página Principal A
                        </Link>

                        {/* ADMINISTRATIVO */}
                        <div className="nav-section mt-2">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseAdministrativo"
                                aria-expanded="false"
                                aria-controls="collapseAdministrativo"
                            >
                                <span>
                                    <i className="fas fa-hospital-user me-2" />
                                    Administrativo
                                </span>
                                <i className="fas fa-chevron-down small" />
                            </div>

                            <div className="collapse" id="collapseAdministrativo" data-bs-parent="#sidenavAccordion">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/administrativo/reportepersonal" className="nav-sub-link">Reporte del personal</Link>
                                    <Link to="/administrativo/IngresarDocente" className="nav-sub-link">Ingresar Colaborador</Link>
                                </nav>
                            </div>
                        </div>

                        {/* ASIGNATURAS */}
                        <div className="nav-section mt-1">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseAsignaturas"
                                aria-expanded="false"
                                aria-controls="collapseAsignaturas"
                            >
                                <span>
                                    <i className="fas fa-graduation-cap me-2" />
                                    Asignaturas
                                </span>
                                <i className="fas fa-chevron-down small" />
                            </div>

                            <div className="collapse" id="collapseAsignaturas" data-bs-parent="#sidenavAccordion">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/administrativo/AsignaturasEstCarreraCicloAdm" className="nav-sub-link">Asignaturas Carrera Ciclo</Link>
                                    <Link to="/administrativo/AsignaturasDocentePeriodoAdm" className="nav-sub-link">Asignaturas Docente Periodo</Link>
                                </nav>
                            </div>
                        </div>

                        {/* INSCRIPCIONES */}
                        <div className="nav-section mt-1">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseInscripciones"
                                aria-expanded="false"
                                aria-controls="collapseInscripciones"
                            >
                                <span>
                                    <i className="fas fa-clipboard me-2" />
                                    Inscripciones
                                </span>
                                <i className="fas fa-chevron-down small" />
                            </div>

                            <div className="collapse" id="collapseInscripciones" data-bs-parent="#sidenavAccordion">
                                <nav className="nav flex-column ms-3">
                                    {/* Agrega items cuando los tengas */}
                                </nav>
                            </div>
                        </div>

                        {/* MATRÍCULAS */}
                        <div className="nav-section mt-1">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseMatriculas"
                                aria-expanded="false"
                                aria-controls="collapseMatriculas"
                            >
                                <span>
                                    <i className="far fa-sticky-note me-2" />
                                    Matrículas
                                </span>
                                <i className="fas fa-chevron-down small" />
                            </div>

                            <div className="collapse" id="collapseMatriculas" data-bs-parent="#sidenavAccordion">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/administrativo/ListarPagosMatricula" className="nav-sub-link">Pagos de Matrícula</Link>
                                </nav>
                            </div>
                        </div>

                        {/* PAGOS */}
                        <div className="nav-section mt-1">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePagos"
                                aria-expanded="false"
                                aria-controls="collapsePagos"
                            >
                                <span>
                                    <i className="fas fa-cash-register me-2" />
                                    Pagos
                                </span>
                                <i className="fas fa-chevron-down small" />
                            </div>

                            <div className="collapse" id="collapsePagos" data-bs-parent="#sidenavAccordion">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/administrativo/ColegiaturasEstCarreraCicloAdm" className="nav-sub-link">
                                        Colegiaturas Estudiante Carrera
                                    </Link>
                                    <Link to="/administrativo/ColegiaturasEstColegiaturaUnPagoAdm" className="nav-sub-link">
                                        Colegiaturas (Un Pago)
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* HISTORIAS CLÍNICAS */}
                        <div className="nav-section mt-1">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseHistorias"
                                aria-expanded="false"
                                aria-controls="collapseHistorias"
                            >
                                <span>
                                    <i className="fas fa-briefcase-medical me-2" />
                                    Historias Clínicas
                                </span>
                                <i className="fas fa-chevron-down small" />
                            </div>

                            <div className="collapse" id="collapseHistorias" data-bs-parent="#sidenavAccordion">
                                <nav className="nav flex-column ms-3">
                                    {/* Agrega items cuando los tengas */}
                                </nav>
                            </div>
                        </div>

                        {/* PERFIL */}
                        <div className="nav-section mt-1">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePerfil"
                                aria-expanded="false"
                                aria-controls="collapsePerfil"
                            >
                                <span>
                                    <i className="far fa-user me-2" />
                                    Perfil
                                </span>
                                <i className="fas fa-chevron-down small" />
                            </div>

                            <div className="collapse" id="collapsePerfil" data-bs-parent="#sidenavAccordion">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/administrativo/VerPerfilAdm" className="nav-sub-link">Ver Perfil</Link>
                                </nav>
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="sb-sidenav-footer text-white bg-azul-light text-center py-3 small">
                        Usuario:
                        <br />
                        {cookie.get("nombres")} {cookie.get("apellidos")}
                    </div>
                </nav>
            </div>
        )
    }
}

export default withRouter(Sidebar);
